import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { CardActions } from "@mui/material";
import { Link } from "@mui/material";
import { useSelector } from "react-redux";
import { IMAGE_URL } from "config";

export const CheckoutAddon = ({ selectedAddon }) => {

    return (
        <>
            <Box
                component="container"
                sx={{
                    mt: "30px",
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "24px",
                    // border: "1px solid green",
                    paddingLeft:"30px"
                }}
            >
                <Grid container spacing={4}>

                    {
                        // mealCourse &&
                        selectedAddon?.map((v, i) => {
                            console.log(`${IMAGE_URL}${v?.addOn?.image?.img}`);
                            return (
                                <>
                                    <Box sx={{ width: "100%" }}>
                                        <Box
                                            // ml="24px"
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                marginTop: "24px",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    // marginTop: "24px",
                                                }}
                                            >
                                                <Box sx={{ width: "111.35px", height: "125.24px" }}>
                                                    <img src={`${IMAGE_URL}${v?.addOn?.image?.img}`} alt="" width="100%" />
                                                </Box>
                                                <Box sx={{ paddingLeft: "22.65px" }}>
                                                    <Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    lg: "24px",
                                                                    md: "24px",
                                                                    sm: "20px",
                                                                    xs: "16px",
                                                                },
                                                                fontWeight: "600",
                                                            }}
                                                        >
                                                            {v.addOn.title}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    lg: "18px",
                                                                    md: "18px",
                                                                    sm: "16px",
                                                                    xs: "12px",
                                                                },
                                                                fontWeight: "400",
                                                            }}
                                                        >
                                                            {v.addOn.quantity} Dishes Selected
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Link
                                                            component="button"
                                                            sx={{
                                                                fontWeight: "400",
                                                                fontSize: {
                                                                    lg: "16px",
                                                                    md: "16px",
                                                                    sm: "14px",
                                                                    xs: "12px",
                                                                },
                                                            }}
                                                        >
                                                            Edit
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </Box >

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    paddingLeft: "24px",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        // paddingTop: "30px",
                                                        paddingRight: {
                                                            lg: "24px",
                                                            md: "24px",
                                                            sm: "24px",
                                                            xs: "10px",
                                                        },
                                                    }}
                                                >
                                                    <Box>
                                                        <Link component="button">
                                                            <img
                                                                src="./images/minusGreen.svg"
                                                                alt=""
                                                                width="100%"
                                                            />
                                                        </Link>
                                                    </Box>
                                                    <Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: {
                                                                    lg: "24px",
                                                                    md: "24px",
                                                                    sm: "20px",
                                                                    xs: "14px",
                                                                },
                                                                fontWeight: "600",
                                                                paddingLeft: "16px",
                                                                paddingRight: "16px",
                                                                paddingTop: {
                                                                    lg: "0px",
                                                                    md: "0px",
                                                                    sm: "5px",
                                                                    xs: "3px",
                                                                },
                                                            }}
                                                        >
                                                            {v.quantity}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Link component="button">
                                                            <img
                                                                src="./images/Frame 787.svg"
                                                                alt=""
                                                                width="100%"
                                                            />
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </>
                            );
                        })
                    }


                </Grid >
            </Box >
        </>
    );
};